import React, { useMemo } from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout'
import { MetaData } from '../components/common/meta'
import Search from '../components/Search'
import Card from '../components/Card'

function KnowledgeBase({ location }) {
  const {
    allGhostTag: { nodes: tags },
    allGhostPost: { nodes: posts },
  } = useStaticQuery(graphql`
    query KnowledgeBaseQuery {
      allGhostTag(
        filter: {
          slug: {
            in: [
              "the-basics"
              "friends-family"
              "your-assets"
              "your-wishes"
              "what-happens-next"
              "glossary"
            ]
          }
        }
      ) {
        nodes {
          ...GhostTagFields
        }
      }
      allGhostPost(
        filter: { tags: { elemMatch: { slug: { eq: "knowledge-base" } } } }
      ) {
        nodes {
          ...GhostPostFields
        }
      }
    }
  `)

  const orderedTagGroups = useMemo(
    () => [
      [
        tags.find((tag) => tag.slug === 'the-basics'),
        tags.find((tag) => tag.slug === 'friends-family'),
      ],
      [
        tags.find((tag) => tag.slug === 'your-assets'),
        tags.find((tag) => tag.slug === 'your-wishes'),
      ],
      [
        tags.find((tag) => tag.slug === 'what-happens-next'),
        tags.find((tag) => tag.slug === 'glossary'),
      ],
    ],
    [tags],
    [tags],
  )

  return (
    <>
      <MetaData location={location} title="Knowledge Base" type="website" />
      <Layout>
        <article className="page type-page status-publish hentry">
          <Search />
          <div className="et_pb_section">
            <div className="et_pb_row">
              {orderedTagGroups.map((tagGroup) => (
                <div
                  key={tagGroup.map(({ slug }) => slug).join('/')}
                  className="et_pb_column et_pb_column_1_3"
                >
                  {tagGroup.map((tag) => (
                    <Card key={tag.slug} title={tag.name}>
                      <p>{tag.description}</p>
                      <br />
                      <ul className="lcp_catlist" id="lcp_instance_0">
                        {posts
                          .filter((post) =>
                            post.tags
                              .map(({ slug }) => slug)
                              .includes(tag.slug),
                          )
                          .map((post) => (
                            <li key={post.id}>
                              <Link to={`/${post.slug}`} title={post.title}>
                                {post.title}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </Card>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </article>
      </Layout>
    </>
  )
}

KnowledgeBase.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default KnowledgeBase
